import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(username, newUsername) {
  return yield oncallFetch("/api/oncall/partners/users/change-username", {
    username,
    newUsername,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/users/change-username.js